/**
 * The single placeholder every section route renders in this phase. It takes
 * the section's heading key so that when a real screen replaces it, the
 * heading key does not change.
 */
import { Box, Stack, Typography } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';

export interface SectionPlaceholderProps {
  titleKey: string;
  titleFallback: string;
}

export function SectionPlaceholder({ titleKey, titleFallback }: SectionPlaceholderProps) {
  const { t } = useCopy();
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh', textAlign: 'center' }}>
      <Stack spacing={1}>
        <Typography variant="h1" component="h1">
          {t(titleKey, titleFallback)}
        </Typography>
        <Typography sx={{ color: 'text.secondary' }}>
          {t('common.comingSoon', 'Coming soon')}
        </Typography>
      </Stack>
    </Box>
  );
}
